import { call, put, takeLatest } from "redux-saga/effects";
import toast from "react-hot-toast";
import * as types from "../actions/actionTypes";
import {
  axiosGet,
  axiosPost,
  axiosPut,
  axiosDelete,
} from "../../utils/common/axios";
import {
  getAllCalculationResponse,
  getCalculationByIdResponse,
} from "../actions";

export function* createCalculationEffectSaga(action) {
  try {
    const { data } = yield call(() =>
      axiosPost(`calculation`, action.data?.payload)
    );
    action.data?.callback?.success?.(data);
    toast.success(data?.message || "Calculation saved successfully");
  } catch (e) {
    console.log(e);
    if (e?.status !== 401) action.data?.callback?.failure?.(e);
  }
}

export function* getAllCalculationEffectSaga(action) {
  try {
    const { data } = yield call(() => axiosGet(`calculation/all`));
    yield put(getAllCalculationResponse(data));
    action?.payload?.callback?.success?.(data);
  } catch (e) {
    console.log(e);
    yield put(getAllCalculationResponse([]));
  }
}

export function* getCalculationByIdEffectSaga(action) {
  try {
    const { data } = yield call(() => axiosGet(`calculation/1`));
    yield put(getCalculationByIdResponse(data));
    action?.payload?.callback?.success?.(data);
  } catch (e) {
    console.log(e);
    yield put(getCalculationByIdResponse([]));
  }
}
export function* getCalculationByCardBundleIdEffectSaga(action) {
  try {
    const { data } = yield call(() =>
      axiosGet(`calculation/cartBundle/${action?.payload?.cartBundleId}`)
    );
    yield put(getCalculationByIdResponse(data));
    action?.payload?.callback?.success?.(data);
  } catch (e) {
    console.log(e);
    yield put(getCalculationByIdResponse([]));
  }
}

export function* deleteCalculationEffectSaga(action) {
  try {
    const { data } = yield call(() => axiosDelete(`calculation/2`));
    action.payload?.callback?.success?.(data);
    toast.success(data?.message || "Calculation deleted successfully");
  } catch (e) {
    console.log(e);
    if (e?.status !== 401) action.payload?.callback?.failure?.(e);
  }
}

export function* updateCalculationEffectSaga(action) {
  try {
    const { data } = yield call(() =>
      axiosPut(`calculation/1`, action.data?.payload)
    );
    action.data?.callback?.success?.(data);
    toast.success(data?.message || "Calculation updated successfully");
  } catch (e) {
    console.log(e);
    if (e?.status !== 401) action.data?.callback?.failure?.(e);
  }
}

export function* calculationWatcherSaga() {
  yield takeLatest(types.CREATE_CALCULATION, createCalculationEffectSaga);
  yield takeLatest(types.GET_ALL_CALCULATION, getAllCalculationEffectSaga);
  yield takeLatest(types.GET_CALCULATION, getCalculationByIdEffectSaga);
  yield takeLatest(types.DELETE_CALCULATION, deleteCalculationEffectSaga);
  yield takeLatest(types.UPDATE_CALCULATION, updateCalculationEffectSaga);
  yield takeLatest(types.GET_CALCULATION_BY_CARDBUNDLE_ID, getCalculationByCardBundleIdEffectSaga);
}
